import type { ComponentProps, ReactNode } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import clsx from 'clsx';
import { cn } from '@/lib/utils';

// Radixui themes
import { SegmentedControl } from '@radix-ui/themes';

interface RootProps extends ComponentProps<typeof SegmentedControl.Root> {
  children: ReactNode;
}

const HubertSegmentedControl = ({ children, ...props }: RootProps) => {
  return (
    <SegmentedControl.Root
      {...props}
      className={
        clsx()
        // 'bg-gray-50',
      }
    >
      {children}
    </SegmentedControl.Root>
  );
};

const itemVariants = cva(clsx(), {
  variants: {
    size: {
      default: 'px-2 py-0 text-base',
      sm: 'p-1 text-xs',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

interface ItemProps extends ComponentProps<typeof SegmentedControl.Item>, VariantProps<typeof itemVariants> {
  children: ReactNode;
}

const Item = ({ className = '', size, children, ...props }: ItemProps) => {
  return (
    <SegmentedControl.Item className={cn(itemVariants({ size, className }))} {...props}>
      {/* <span
        // className={cn(itemVariants({ size, className }))}
      >
      </span> */}
      {children}
    </SegmentedControl.Item>
  );
};

HubertSegmentedControl.Item = Item;
export default HubertSegmentedControl;
